import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { useSelector } from 'react-redux';

import selectors from '../../store/selectors';

export const MassListContext = React.createContext({
  selectedDate: null,
  setSelectedDate: null,
});

const getMoment = _.memoize(() => moment());
const getInitialDate = preselectedDate => {
  const preselectedMoment = moment(preselectedDate);
  return preselectedMoment.isValid() ? preselectedMoment : getMoment();
};

export const MassListContextProvider = ({ preselectedDate, children }) => {
  const soonestMassWithFreeSlot = useSelector(selectors.getSoonestMassWithFreeSlot);
  const [selectedDate, setSelectedDate] = useState(getInitialDate(preselectedDate));

  useEffect(() => {
    if (soonestMassWithFreeSlot && !preselectedDate) {
      setSelectedDate(moment(soonestMassWithFreeSlot.massDate));
    }
  }, [preselectedDate, soonestMassWithFreeSlot]);

  return (
    <MassListContext.Provider
      value={{
        selectedDate,
        setSelectedDate,
      }}
    >
      {children}
    </MassListContext.Provider>
  );
};

MassListContextProvider.propTypes = {
  children: PropTypes.node,
  preselectedDate: PropTypes.string,
};
